import * as O from 'fp-ts/lib/Option';
import {
    IndexFilter_Config,
    IndexFilter_ControlsState,
    IndexFilter_Snapshot,
    IndexFilter_State,
    IndexFilters_ControlsState,
} from './types/indices.type';

export class IndexFilter {
    public createStateFromConfig(config: IndexFilter_Config): IndexFilter_State {
        return {
            ...config,
        };
    }

    public createControlsStateFromConfig(config: IndexFilter_Config): IndexFilter_ControlsState {
        return {
            identifier: config.identifier,
            isChecked: false,
        };
    }

    public updateControlsState(controlsState: IndexFilter_ControlsState, check: boolean): IndexFilter_ControlsState {
        return {
            ...controlsState,
            isChecked: check,
        };
    }

    public includeInSnapshot(controlsState: IndexFilter_ControlsState): boolean {
        return controlsState.isChecked;
    }

    public createSnapshotFromState(controlsState: IndexFilter_ControlsState): O.Option<IndexFilter_Snapshot> {
        if (controlsState.isChecked) {
            return O.some(controlsState.identifier);
        }
        return O.none;
    }

    public createStateFromSnapshot(
        snapshot: IndexFilter_Snapshot,
        controlsState: IndexFilter_ControlsState
    ): IndexFilter_ControlsState {
        if (snapshot === controlsState.identifier) {
            return {
                ...controlsState,
                isChecked: true,
            };
        }
        return controlsState;
    }
}
